/*@flow*/
import useCachedQuery from 'lib/useCachedQuery';
import GetPrimaryDistrictId from './queries/GetPrimaryDistrictId';
import * as I from 'immutable';

export default function usePrimaryDistrictId(): any {
  const { data } = useCachedQuery(GetPrimaryDistrictId);
  return I.fromJS(data).getIn(['me', 'company', 'primaryDistrictId']);
}
